import { cloneElement, isValidElement, ReactNode, SVGProps } from "react";

interface NodeIconProps extends SVGProps<SVGElement> {
  children: ReactNode;
}

export default function NodeIcon({ children, ...otherProps }: NodeIconProps) {
  if (typeof children === "string") return <>{children}</>;

  return (
    <>
      {children &&
        isValidElement(children) &&
        cloneElement(children, otherProps)}
    </>
  );
}
